<template>
  <div>
    <div class="circulation">
      <!-- <div class="title">流通信息</div> -->
      <div class="item-wrap">
        <div class="left" v-if="enterprise">
          <div class="tle">生产商</div>
          <div class="item">
            <!-- {{ options.business.bussinessName  }} -->
            名称: <span>{{ enterprise.msgItems[0].op.op.business_name }} </span>
          </div>
          <div class="item">
            <!--{{ options.business.addressDetail  }} -->
            地址:
            <span>
              {{
                (enterprise.msgItems[0].op.op.province || "") +
                (enterprise.msgItems[0].op.op.city || "") +
                (enterprise.msgItems[0].op.op.addressdetail || "")
              }}</span
            >
          </div>
          <div class="item">
            <!--{{ options.business.phone  }} -->
            联系电话:
            <span>{{
              enterprise.msgItems[0].op.op.mobile ||
              enterprise.msgItems[0].op.op.phone
            }}</span>
          </div>
        </div>
        <div class="left" v-if="enterprise">
          <div class="tle">经销商</div>
          <div class="item">
            <!-- {{ options.business.bussinessName  }} -->
            店铺名称: <span>{{ logistics.shop_name || "" }} </span>
          </div>
          <div class="item">
            <!--{{ options.business.addressDetail  }} -->
            客服电话：
            <span>
              {{ logistics.shop_tel || "" }}
            </span>
          </div>
        </div>

        <!-- <div class="left">
        <div class="tle">当前经销商 </div>
        <div class="item">名称: <span> </span></div>
        <div class="item">地址: <span></span></div>
        <div class="item">联系电话: <span> </span></div>
      </div> -->
      </div>
    </div>
    <PageContent
      :dataList="packing"
      v-if="Object.keys(packing).length && packing.msgItems"
      title="包装信息"
      ref="pageContentRefPack"
    >
      <template v-slot="itemData">
        <div class="enterPriseInfo">
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 包装规格：</span>
            </div>
            <div class="content-item">
              <span v-if="itemData.itemData.op.op.longvalue">{{
                itemData.itemData.op.op.longvalue +
                "×" +
                itemData.itemData.op.op.widthvalue +
                "×" +
                itemData.itemData.op.op.heightvalue +
                sizeType[itemData.itemData.op.op.sizeunit]
              }}</span>
            </div>
          </template>
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 包含商品数量：</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.contains_number }}</span>
            </div>
          </template>
        </div>
      </template>
    </PageContent>
    <!-- v-if="Object.keys(logistics).length&&logistics.msgItems" -->
    <PageContent
      :dataList="logisticsNode"
      v-if="Object.keys(logisticsNode).length && logisticsNode.msgItems"
      title="物流信息"
      ref="pageContentReflog"
    >
      <template v-slot="itemData">
        <div class="enterPriseInfo">
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 物流公司</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.express_company }}</span>
            </div>
          </template>
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 物流单号</span>
            </div>
            <div
              class="content-item"
              style="display: flex; align-items: center"
            >
              <span>{{ itemData.itemData.op.op.tracking_no }}</span>
              <img
                src="@/assets/images/copy_.png"
                @click="copy(itemData.itemData.op.op.tracking_no)"
                style="margin-left: 10px"
                class="image_x_size"
                alt=""
              />
            </div>
          </template>
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 操作员</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.create_by_name }}</span>
            </div>
          </template>
        </div>
      </template>
    </PageContent>
    <PageContent
      :dataList="businessListData"
      title="交易信息"
      ref="pageContentRef"
      v-if="Object.keys(businessListData).length"
    >
      <template v-slot="itemData">
        <div class="enterPriseInfo">
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 订单号:</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.shop_orderId }}</span>
            </div>
          </template>
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 下单时间：</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.created_date }}</span>
            </div>
          </template>
        </div>
      </template>
    </PageContent>
  </div>
</template>

<script>
export default {
  data() {
    return {
      businessListData: {},
      packing: {},
      logistics: {},
      logisticsNode: {},
      sizeType: { 0: "cm", 1: "dm", 2: "m" },
      options: {
        chainBusiness: {
          business: {},
          chainScanCode: {},
          packageInfo: {},
          apackage: {},
        },
      },
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    try {
      this.$setApptitle("链白茶防伪溯源");
    } catch {
      console.log("not webview");
    }

    //生产商环节---企业信息
    this.enterprise = JSON.parse(localStorage.getItem("idInObj"))[3];
    console.log(this.enterprise);
    //包装环节
    this.packing =
      JSON.parse(localStorage.getItem("idInObj"))[5] || {};
    //流通信息
    this.logistics = JSON.parse(localStorage.getItem("idInObj"))[6];
    //交易信息
    this.businessListData =
      JSON.parse(localStorage.getItem("idInObj"))[8] || {};
    //物流环节
    this.logisticsNode = JSON.parse(localStorage.getItem("idInObj"))[9] || {};

    // const {data:res} = await this.$api.getDataApi()
    // this.options = res.chainBusiness
    // console.log(res.chainBusiness);
    //  let getItem = JSON.parse(localStorage.getItem('getItemVal'))
    //  this.options = getItem.v
    //  console.log(this.options)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {
    copy(str) {
      this.$CopyStr(str);
    },
  },
};
</script>
<style lang="scss" scoped>
.circulation {
  padding: 0 40px;
  .item-wrap {
    .left {
      position: relative;
      margin-bottom: 32px;
      padding-left: 40px;
      border-left: 5px solid #26907a;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      &:first-child {
        .tle {
          // background-color: rgb(43, 41, 41);
          top: -10px;
        }
      }
      &:first-child::before {
        content: "";
        position: absolute;
        top: 0;
        left: -3px;
        transform: translateX(-50%);
        width: 28px;
        height: 28px;
        background: #ffffff;
        border: 5px solid #26907a;
        border-radius: 50%;
      }
      .tle {
        position: relative;
        top: 5px;
        padding: 14px 32px;
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        background-color: #26907a;
        font-size: 28px;
        color: #fff;
        border-radius: 16px;
        &::before {
          position: absolute;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
          content: "";
          width: 12px;
          height: 8px;
          background: #26907a;
        }
      }
      .first {
        top: -14px;
      }
      .item {
        margin-top: 20px;
        // background-color: pink;
        margin-bottom: 16px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #222222;
        span {
          font-size: 28px;
          color: #808080;
        }
      }
    }
  }
}
.copy_wul {
  font-size: 12px;
  border-radius: 50px;
  background-color: #efefef;
  padding: 0 15px;
  color: #222222 !important;
}
.enterPriseInfo {
  .item {
    // margin-bottom: 54px;
    margin-top: 20px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: #222222;
    .item-icon {
      width: 8px;
      height: 8px;
      background-color: #26907a;
      margin-right: 16px;
    }
    span.title-item {
      color: #222222;
      font-size: 28px;
      font-weight: bold;
    }
    img {
      float: right;
      width: 40px;
      height: 40px;
    }
  }
}
.p-top {
  padding-top: 14px;
}
::v-deep .goods-info-content {
  padding-right: 20px;
  padding-left: 20px;
}
.image-alert {
  img {
    width: 300px;
    height: 300px;
  }
}
.btn {
  width: 510px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background-color: #26907a;
  border-radius: 16px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 40px;
}
.btn:not(:first-child) {
  margin-top: 20px;
}
.content-item {
  margin-top: 15px;
  padding-bottom: 16px;
  padding-left: 20px;
  border-bottom: 1px solid #d4d6d5;
  span {
    height: 40px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: #808080;
  }
}
.image_x_size {
  width: 32px;
  height: 32px;
}
</style>
